function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "m23.4 25h15.1c.4 0 .8-.1 1.1-.4s.4-.6.4-1.1v-9.9c0-.4-.1-.8-.4-1.1s-.6-.4-1.1-.4h-15.1c-.4 0-.8.1-1.1.4s-.4.6-.4 1.1v9.9c0 .4.1.8.4 1.1s.6.4 1.1.4zm-16.4 15c-.8 0-1.5-.3-2.1-.9s-.9-1.3-.9-2.1v-26c0-.8.3-1.5.9-2.1s1.3-.9 2.1-.9h34c.8 0 1.5.3 2.1.9s.9 1.3.9 2.1v26c0 .8-.3 1.5-.9 2.1s-1.3.9-2.1.9z",
  fill: "#5f6368"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/provider-logo-settings.8c606de4.svg";
export { SvgComponent as ReactComponent };